import React from 'react';
import CmsPage from '@/components/routing/CmsPage';

// Native Base44 page for /hair-consultation-athens
// Content source: LandingPage record, slug "hair-consultation-athens" (published)
export default function HairConsultationAthens() {
  return <CmsPage slug="hair-consultation-athens" kind="landing" />;
}